var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListagemBase',{attrs:{"nomePlural":"LogTransacoes","nomeSingular":"LogTransacao","headers":_vm.headers,"botaoCadastro":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }